import axios from "../../axios";

export const CreateGrihaLead = async (
	title,
	insuredName,
	contactNumber,
	email,
	dateOfBirth,
	premiumUID
) => {
	const payload = {
		title,
		insuredName,
		contactNumber,
		email,
		dateOfBirth,
		premiumUID,
	};

	try {
		const response = await axios.post(
			"/api/Griha/GrihaLead/CreateLead",
			payload
		);

		return response;
	} catch (error) {
		if (error.response) {
			console.log("API Error:", error.response.data);
			throw new Error(error.response.data.message || "Failed");
		}

		throw new Error("Network Error");
	}
};

export const GetGrihaLeadDetails = async (uid) => {
	return await axios.post("/api/Griha/GrihaLead/GetGrihaLeadDetails", {
		grihaLeadUID: uid,
	});
};

export const UpdateGrihaLeadDetails = (payload) => {
	return axios.post("/api/Griha/GrihaLead/UpdateGrihaLeadDetails", payload);
};
